/**
 * AcessosKeyboardShortcuts — provider de atalhos globais para a area
 * /acessos/*. Sprint 6 do plano.
 *
 * Atalhos:
 *   g u  -> /acessos/usuarios
 *   g c  -> /acessos/cargos
 *   g a  -> /acessos/auditoria
 *   g s  -> /acessos/conflitos-sod
 *   g h  -> /acessos (hub)
 *   n    -> /acessos/usuarios/novo (na lista)
 *   /    -> foca o primeiro input[type=search] da pagina
 *   ?    -> abre overlay de ajuda
 *   Esc  -> fecha overlay
 */
import React, { useState } from "react";
import styled from "styled-components";
import { FiX } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

import { useKeyboardShortcuts } from "../../hooks/useKeyboardShortcuts";

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
`;

const Modal = styled.div`
  background: ${({ theme }) => theme.surface};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 16px;
  padding: 22px 26px;
  width: min(90vw, 460px);
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Title = styled.h3`
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: ${({ theme }) => theme.textPrimary};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Close = styled.button`
  background: transparent;
  border: 0;
  color: ${({ theme }) => theme.textSecondary};
  cursor: pointer;
  padding: 4px;
`;

const Lista = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Item = styled.li`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 0.9rem;
  padding: 6px 0;
  border-bottom: 1px dashed ${({ theme }) => theme.border};

  &:last-child {
    border-bottom: 0;
  }
`;

const Kbd = styled.kbd`
  font-family: var(--font-mono, ui-monospace, monospace);
  background: ${({ theme }) => theme.surfaceAlt};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 4px;
  padding: 1px 6px;
  font-size: 0.8rem;
`;

const ATALHOS = [
  { tecla: "g u", descricao: "Ir para Usuários" },
  { tecla: "g c", descricao: "Ir para Cargos" },
  { tecla: "g a", descricao: "Ir para Auditoria" },
  { tecla: "g s", descricao: "Ir para Conflitos SoD" },
  { tecla: "g h", descricao: "Ir para Hub de Acessos" },
  { tecla: "n", descricao: "Novo usuário (na lista)" },
  { tecla: "/", descricao: "Focar busca da página" },
  { tecla: "?", descricao: "Mostrar/esconder esta ajuda" },
  { tecla: "Esc", descricao: "Fechar painel/dialog" },
];

function focarPrimeiroSearchInput() {
  const el = document.querySelector(
    'input[type="search"], input[placeholder*="buscar" i], input[placeholder*="filtrar" i]'
  );
  if (el && typeof el.focus === "function") {
    el.focus();
  }
}

function AcessosKeyboardShortcuts() {
  const navigate = useNavigate();
  const [helpOpen, setHelpOpen] = useState(false);

  useKeyboardShortcuts({
    "g u": () => navigate("/configuracoes/acessos/usuarios"),
    "g c": () => navigate("/configuracoes/acessos/cargos"),
    "g a": () => navigate("/configuracoes/acessos/auditoria"),
    "g s": () => navigate("/configuracoes/acessos/conflitos-sod"),
    "g h": () => navigate("/configuracoes/acessos"),
    n: () => navigate("/configuracoes/acessos/usuarios/novo"),
    "/": () => focarPrimeiroSearchInput(),
    "?": () => setHelpOpen((v) => !v),
    Escape: () => setHelpOpen(false),
  });

  if (!helpOpen) return null;
  return (
    <Overlay onClick={() => setHelpOpen(false)}>
      <Modal onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <Title>
          Atalhos de teclado
          <Close type="button" onClick={() => setHelpOpen(false)} aria-label="Fechar">
            <FiX size={18} />
          </Close>
        </Title>
        <Lista>
          {ATALHOS.map((a) => (
            <Item key={a.tecla}>
              <span>{a.descricao}</span>
              <Kbd>{a.tecla}</Kbd>
            </Item>
          ))}
        </Lista>
      </Modal>
    </Overlay>
  );
}

export default AcessosKeyboardShortcuts;
